export enum OrderState {
  NEW,
  SAVED,
  DIRTY
}
